let inform = {
    title: "消息通知",
    state: {
        title: "状态",
        placeholder: "请选择状态",
        value0: "全部",
        value1: "未读",
        value2: "已读",
    },
    filtersTitle: "通知标题",
    titlePlaceholder: "请输入标题",
    filtersContent: "通知内容",
    contentPlaceholder: "请输入内容",
    columns: {
        title: "通知标题",
        publishTime: "下发时间",
        stateStr: "状态",
        content: "通知内容",
        managerName: "发送人",
    },
    read: "已读",
    warn: "请选择要已读的通知",
    confirm: "确定要标记为已读吗？",
    details: {
        title: "消息详情",
        list01: "通知标题",
        list02: "下发时间",
        list03: "已读时间",
        list04: "状态",
        list05: "通知内容",
        list06: "发送人",
    }
}

export default inform